<template>
  <div v-if="this.$store.getters.isAdmin">
    <v-tabs
      v-model="selectedTab"
      background-color="pink lighten-2"
      grow
      icons-and-text
      dark
      class="mb-10"
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-clients">
        Clients
      </v-tab>
      <v-tab href="#tab-userRights">
        Droits utilisateurs
      </v-tab>
      <v-tab href="#tab-users">
        Utilisateurs
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item value="tab-clients">
        <Clients></Clients>
      </v-tab-item>
      <v-tab-item value="tab-userRights">
        <UserRights></UserRights>
      </v-tab-item>
      <v-tab-item value="tab-users">
        <Users></Users>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Clients from "@/components/admin/client/forms/tabs/clients.vue";
import UserRights from "@/components/admin/userRight/forms/tabs/userRights.vue";
import Users from "@/components/admin/user/forms/tabs/users.vue";

export default {
  name: "clientManagement",
  components: {
    UserRights,
    Clients,
    Users,
  },
  data: () => ({
    selectedTab: null,
  }),
  
  watch: {
    selectedTab(value) {
      localStorage.selectedTab = value;
    }
  },

  mounted() {
    if (localStorage.selectedTab) {
       this.selectedTab = localStorage.selectedTab;
    } 
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients"},
      { title: "Gestion des comptes" },
    ]);
  },
};
</script>
